<template>
  <div style="padding-right: 30px;padding-top:30px">
    <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="100px" label-position="left">
      <el-form-item label="车牌号" prop="name">
        <el-select v-model="ruleForm.vehicleCode" filterable placeholder="点击或输入选择" style="width:100%" clearable>
          <el-option
            v-for="item in options"
            :key="item.code"
            :label="item.licenseNumber"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="费用项目" prop="feeType">
        <el-input v-model="ruleForm.feeType" clearable placeholder="请输入费用项目" />
      </el-form-item>
      <el-form-item label="金额" prop="fee">
        <el-input v-model="ruleForm.fee" clearable placeholder="请输入金额" />
      </el-form-item>
      <el-form-item label="办理时间" prop="handleTime">
        <el-date-picker
          v-model="ruleForm.handleTime"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="optionsPicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="value => changeDate(value, 'gmtCreated')"
        />
        <!-- <el-input v-model="ruleForm.description" clearable placeholder="请输入描述内容"></el-input> -->
      </el-form-item>

      <el-form-item label="到期时间" prop="expireTime">
        <el-date-picker
          v-model="ruleForm.expireTime"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="optionsPicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="value => changeDate(value, 'gmtCreated')"
        />
      </el-form-item>
      <el-form-item label="提前预警天数" prop="advanceDay">
        <el-input v-model="ruleForm.advanceDay" clearable placeholder="请输入描述内容" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="funcSubmit">立即处理</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import {updateCtmsVehiclePrescribeFee} from "@/api/vehicleService";
  import request from '@/utils/request'
  export default {
    name: "Edit",
    data() {
      return {
        ruleForm: {
          code: '',
          description: '',
          vehicleCode: '',
          name: '',
          feeType: '',
          fee: '',
          handleTime: '',
          expireTime: '',
          advanceDay: ''
        },
        
        rules: {
          vehicleCode: [
            { required: true, message: "请输入车牌号", trigger: "change" }
          ],
          feeType: [
            { required: true, message: "请输入费用项目", trigger: "blur" }
          ],
          fee: [
            { required: true, message: "请输入金额", trigger: "blur" }
          ],
          handleTime: [
            { required: true, message: "请选择办理时间", trigger: "change" }
          ],
          expireTime: [
            { required: true, message: "请选择到期时间", trigger: "change" }
          ],
          advanceDay: [
            { required: true, message: "请输入提前预警天数", trigger: "blur" }
          ]
        },
        options: [],
        value: '',
      };
    },
    created() {
      this.getVehicleList();
    },
    methods: {
      getVehicleList() {
        request({url: `/ntocc-basic-api/vehicle/list`, method: 'get'}).then(response => {
          this.options = response.data
        })
      },
      getInfo(code) {
        request({url: `/ntocc-basic-api/ctmsVehiclePrescribeFee/${code}`, method: 'get'}).then(response => {
          this.ruleForm = response.data
        })
      },
      funcSubmit() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            const rLoading = this.openLoading();
            updateCtmsVehiclePrescribeFee(this.ruleForm).then(response => {
              rLoading.close();
              this.$message({message: response.msg, type: 'success'})
              this.$emit('hideModel')
            })
          } else {
            return false
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  };
</script>
